const WRITE_OFFERS = 'write_offers';
const WRITE_CONTACTS = 'write_contacts';
const WRITE_PRODUCTS = 'write_products';
const WRITE_PROJECTS = 'write_projects';
// Read-only access, the matching write permission always includes reading
const READ_CONTACTS = 'read_contacts';
// The log of who opened, calculated and saved the offers, for every offer
const READ_LOG = 'read_log';
const READ_OFFERS = 'read_offers';
const READ_PRODUCTS = 'read_products';
const READ_PROJECTS = 'read_projects';
const DELETE_OFFERS = 'delete_offers';
const DELETE_OFFER_TEXTS = 'delete_offer_texts';
// Adding, renaming and hiding the choices of the dropdown lists of the offers
const MANAGE_OFFER_CHOICES = 'manage_offer_choices';
const WRITE_PRODUCT_CONFIGURATIONS = 'write_product_configurations';
const DELETE_CONFIGURATIONS = 'glass_configurator/delete_glass_configurations';
const DELETE_PRODUCT_CONFIGURATIONS = 'delete_product_configurations';
const WRITE_CONFIGURATIONS = 'glass_configurator/write_glass_configurations';

export {
  WRITE_OFFERS,
  WRITE_CONTACTS,
  WRITE_PRODUCTS,
  WRITE_PROJECTS,
  READ_CONTACTS,
  READ_LOG,
  READ_OFFERS,
  READ_PRODUCTS,
  READ_PROJECTS,
  DELETE_OFFERS,
  DELETE_OFFER_TEXTS,
  MANAGE_OFFER_CHOICES,
  WRITE_PRODUCT_CONFIGURATIONS,
  DELETE_CONFIGURATIONS,
  DELETE_PRODUCT_CONFIGURATIONS,
  WRITE_CONFIGURATIONS,
};
